// NotFoundPage.js
import { connect } from 'react-redux';

import NotFoundPage from '../page/NotFoundPage.jsx';
import getMeData from '../selector/getMeData.js';
import mergeMeData from '../action/mergeMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { UNDER_AGE_EXIT_URL } from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  const meId = getMeData(state, 'id');
  const isAuthed = !!meId;
  const hasAgeVerified = getMeData(state, 'hasAgeVerified');
  return {
    isAuthed,
    hasAgeVerified,
    underAgeExitUrl: getRemoteConfigData(state, UNDER_AGE_EXIT_URL),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mergeMeData: ({ field, value }) => dispatch(mergeMeData({ field, value })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundPage);
